import { Pipe, PipeTransform } from '@angular/core';
import { TimeStampHistoryDetails } from '../business-entities/appointmentDetail-model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Pipe({
  name: 'stringtotimestampdetails'
})
export class StringtotimestampdetailsPipe implements PipeTransform {

  transform(details: any,forJob?:boolean): unknown {
    const arra =[]
    details.forEach(element => {
      if(element?.toString().includes(",")){
      let obj:TimeStampHistoryDetails={
       description:'',
       reason:'',
       timeFrom:null,
       timeTo:null
      }
      let arr = element.split(",");
      if(arr && arr.length >0 && !forJob){
        obj.timeFrom = Utility.ConvertUTCDateToLocalDate(arr[0]);
        obj.timeTo = Utility.ConvertUTCDateToLocalDate(arr[1]);
        obj.reason = arr[2];
      }
      if(arr && arr.length >0 && forJob){
        obj.description = arr[0];
        obj.timeFrom = Utility.ConvertUTCDateToLocalDate(arr[1]);
        obj.timeTo = Utility.ConvertUTCDateToLocalDate(arr[2]);
        obj.reason = arr[3];
      }
      arra.push(obj);
    }
       
    })
    return arra;
  }

}
